import {ItemStyle} from "./ItemStyle";
import {ItemAttribute} from "./ItemAttribute";

export class PostItem {
  id: number |undefined;
  type: string = "";
  priority: number = 0;
  // html_code: string = '';
  // html_not_publish: string = '';
  style: ItemStyle = new ItemStyle();
  itemAttribute: ItemAttribute = new ItemAttribute();
}
